import React, { useMemo } from 'react';
// import PropTypes from 'prop-types';

import * as S from './styled';

function getRandomWidth(min, max) {
  if (min >= max) {
    throw new Error('Minimum value must be less than maximum value');
  }

  const range = (max - min) / 10;
  const randomStep = Math.floor(Math.random() * (range + 1));
  const randomNumber = min + randomStep * 10;

  return randomNumber;
}

const ItemPlaceholder = ({ index }) => {
  const [titleWidth, cardWidth] = useMemo(() => {
    return [getRandomWidth(30, 80), getRandomWidth(30, 80)];
  }, [index]);

  return (
    <S.ItemPlaceholder>
      <S.Columns>
        <S.Title
          delay={`0.${index}s`}
          width={titleWidth}
        />
        <S.CardName
          delay={`0.${index}s`}
          width={cardWidth}
        />
        <S.Divider />
        <S.Footer delay={`0.${index}s`} />
      </S.Columns>
    </S.ItemPlaceholder>
  );
};

ItemPlaceholder.propTypes = {};
ItemPlaceholder.defaultProps = {};

export default ItemPlaceholder;
